import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

import { navigationForProfile, profilesForNavigationItem } from '@/components/layout';

import { useAuth } from './providers/authContext';

// Loaded on demand like every other screen; the shell's Suspense covers it.
const StorefrontHomeRoute = lazy(async () => {
  const { StorefrontHomeRoute: Component } = await import('@/features/catalog');
  return { default: Component };
});

/**
 * The index route cannot point at a fixed module: the catalog is meaningless to controllership
 * and the backoffice is closed to an operator.
 *
 * A profile that buys gets its home here (Figma D1, "Início (/) com a vitrine"): the storefront.
 * Every other profile lands on the first entry it can actually reach; a user with no profile
 * falls through to "Minha organização", whose guard then explains the missing permission instead
 * of leaving a blank screen.
 */
export function HomeRedirect() {
  const { profile } = useAuth();
  if (profile !== null && profilesForNavigationItem('cart').includes(profile)) {
    return <StorefrontHomeRoute />;
  }
  const [first] = navigationForProfile(profile);

  return <Navigate to={first?.to ?? '/minha-organizacao'} replace />;
}
